/**
 * Lista de países soportados en el wizard fiscal (Sprint 10.1d/e).
 *
 * Incluye:
 *   - Toda LATAM (20 países hispanohablantes + Brasil + Haití)
 *   - USA (mercado obligatorio para W-9)
 *   - Canadá, España y Portugal (mercados con relación cercana, comunidad expat LATAM)
 *
 * Códigos en ISO-2 (estándar IRS para W-8BEN / W-9).
 *
 * Mantenido como UNA sola lista plana ordenada alfabéticamente por nombre
 * en español — la usamos en 3 selects del wizard:
 *   - País de ciudadanía (W-8BEN)
 *   - País de residencia fiscal (W-8BEN)
 *   - País de la dirección permanente (W-8BEN; W-9 hardcodea US)
 *
 * Si en producción aparece un Guru de un país fuera de esta lista, sumamos
 * acá y queda inmediato (no requiere cambio de schema).
 */
export interface CountryOption {
  code: string;   // ISO-2 (lo que se guarda en BD y va al PDF)
  name: string;   // Nombre en español (lo que ve el Guru)
}

export const COUNTRIES: CountryOption[] = [
  { code: 'AR', name: 'Argentina' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brasil' },
  { code: 'CA', name: 'Canadá' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'ES', name: 'España' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HT', name: 'Haití' },
  { code: 'HN', name: 'Honduras' },
  { code: 'MX', name: 'México' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'PA', name: 'Panamá' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Perú' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'DO', name: 'República Dominicana' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VE', name: 'Venezuela' },
];

/** Lookup por código ISO-2 (ej. para mostrar el nombre en una pantalla de admin) */
export function getCountryName(code: string | null | undefined): string {
  if (!code) return '—';
  const found = COUNTRIES.find((c) => c.code === code.toUpperCase());
  return found?.name ?? code.toUpperCase();
}
